import { getAllCompanies } from 'src/services/getAllCompanies';
import { baseLoader } from './baseLoader';
import { getQueryParams } from 'src/utils/helpers/queryParams';
import { parseFilters } from 'src/hooks/filters/useFilters';
import { parseSort } from 'src/hooks/filters/useSort';
import { getCompanyStatuses } from 'src/services/getCompanyStatuses';

export const getCompaniesLoader = async ({ request }, types) => {
	const { limit, page } = getQueryParams({ request }, ['limit', 'page']);

	const params = new URL(request.url).searchParams;

	return baseLoader(async () => {
		const [companies, statuses] = await Promise.all([
			getAllCompanies({
				page: Number(page) || 1,
				limit: Number(limit) || 15,
				types,
				filters: parseFilters(params),
				sort: parseSort(params),
			}),
			getCompanyStatuses(),
		]);

		return { ...companies, statuses: statuses.items };
	}, 'Failed to load companies.', request);
};
